// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
  position: fixed;
  font-family: sans-serif;
}

#header .pro-sidebar {
  height: 100vh;
}

#header .closemenu {
  color: rgb(255, 255, 255);
  position: absolute;
  right: 0;
  z-index: 9999;
  line-height: 2px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 25px;
  top: 55px;
  cursor: pointer;
  background-color: transparent;
  border: none;
}

#header .pro-sidebar {
  width: 100%;
  min-width: 100%;
}

#header .pro-sidebar.collapsed {
  width: 10px;
  min-width: 81px;
}

#header .pro-sidebar-inner {
  background-color: rgb(61, 61, 61);
  box-shadow: 0.5px 0.866px 2px 0px rgba(0, 0, 0, 0.15);
}

#header .pro-sidebar-inner .pro-sidebar-layout {
  overflow-y: hidden;
}

.Logo2bad {
  width: 180px;
  height: auto;
  object-fit: cover;
  transition: width 0.5s;
}

.Logo2bad-collapse {
  width: 80px;
  height: auto;
  transition: width 0.5s;
}

#header .pro-sidebar-inner .pro-sidebar-layout .logotext p {
  padding: 0 8px;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul {
  padding: 10 5px;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item:hover {
  transition-duration: 0.4s;
  background-color: rgb(228, 228, 228, 0.6);
  color: rgb(0, 0, 0);
  font-weight: bold;
}

#header
  .pro-sidebar-inner
  .pro-sidebar-layout
  ul
  .pro-inner-item
  .pro-icon-wrapper {
  background-color: transparent;
  color: #ffffff;
}

#header
  .pro-sidebar-inner
  .pro-sidebar-layout
  ul
  .pro-inner-item
  .pro-icon-wrapper
  .pro-item-content {
  color: #000;
}

@media only screen and (max-width: 720px) {
  html {
    overflow: hidden;
  }
}

.svg-icons {
  width: 25px;
  height: 25px;
}
@media screen and (max-width: 50em) {
  .Logo2bad-login{
	width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Navigation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;;EAME,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;;;;;;EAOE,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;CACD,WAAW;EACV;AACF","sourcesContent":["#header {\n  position: fixed;\n  font-family: sans-serif;\n}\n\n#header .pro-sidebar {\n  height: 100vh;\n}\n\n#header .closemenu {\n  color: rgb(255, 255, 255);\n  position: absolute;\n  right: 0;\n  z-index: 9999;\n  line-height: 2px;\n  border-radius: 50%;\n  font-weight: bold;\n  font-size: 25px;\n  top: 55px;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n}\n\n#header .pro-sidebar {\n  width: 100%;\n  min-width: 100%;\n}\n\n#header .pro-sidebar.collapsed {\n  width: 10px;\n  min-width: 81px;\n}\n\n#header .pro-sidebar-inner {\n  background-color: rgb(61, 61, 61);\n  box-shadow: 0.5px 0.866px 2px 0px rgba(0, 0, 0, 0.15);\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout {\n  overflow-y: hidden;\n}\n\n.Logo2bad {\n  width: 180px;\n  height: auto;\n  object-fit: cover;\n  transition: width 0.5s;\n}\n\n.Logo2bad-collapse {\n  width: 80px;\n  height: auto;\n  transition: width 0.5s;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout .logotext p {\n  padding: 0 8px;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout ul {\n  padding: 10 5px;\n}\n\n#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item:hover {\n  transition-duration: 0.4s;\n  background-color: rgb(228, 228, 228, 0.6);\n  color: rgb(0, 0, 0);\n  font-weight: bold;\n}\n\n#header\n  .pro-sidebar-inner\n  .pro-sidebar-layout\n  ul\n  .pro-inner-item\n  .pro-icon-wrapper {\n  background-color: transparent;\n  color: #ffffff;\n}\n\n#header\n  .pro-sidebar-inner\n  .pro-sidebar-layout\n  ul\n  .pro-inner-item\n  .pro-icon-wrapper\n  .pro-item-content {\n  color: #000;\n}\n\n@media only screen and (max-width: 720px) {\n  html {\n    overflow: hidden;\n  }\n}\n\n.svg-icons {\n  width: 25px;\n  height: 25px;\n}\n@media screen and (max-width: 50em) {\n  .Logo2bad-login{\n\twidth: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
